// ─── Portfolio Data — Jay Hitenbhai Khatri ───────────────────────────────────
// Centralized data structure. To add content, add entries to the arrays below.
// No logic lives here — just data.

export const personalInfo = {
  name: "Jay Khatri",
  fullName: "Jay Hitenbhai Khatri",
  title: "Senior Full Stack Engineer",
  tagline: "I build production-ready digital products from idea to deployment.",
  email: "khatrishyamo987@gmail.com",
  phone: "+91 7801985096",
  location: "Ahmedabad, Gujarat",
  availableForWork: true,
  bio: "Senior Full Stack Engineer with 5+ years of experience architecting and delivering AI-native, production-grade SaaS applications at scale. Proven expertise in designing end-to-end systems using React.js, Next.js, Node.js, and cloud infrastructure (AWS), with deep hands-on experience embedding intelligent workflows via OpenAI GPT APIs, LLM fine-tuning, and agentic automation pipelines. Built and shipped features that serve 150,000+ users with 99.9% uptime.",
  stats: [
    { label: "Years Building", value: "5+" },
    { label: "Users Served", value: "150K+" },
    { label: "Platform Uptime", value: "99.9%" },
    { label: "API Response Improved", value: "30%" },
  ],
  social: {
    github: "https://github.com/jaykhatri2910",
    linkedin: "https://www.linkedin.com/in/jay-khatri-1aa3a7185",
  },
  resume:
    "https://drive.google.com/file/d/1OzUmCFIObsBnUPzFRj9j1RRc5EiDxQ-h/view?usp=drive_link", // Set to URL when ready
};

// ─── Projects ─────────────────────────────────────────────────────────────────
// To add a project: append an object following this shape.
// categories: use from ['ai', 'fullstack', 'frontend', 'backend', 'cloud', 'integration', 'mobile']
export const projects = [
  {
    id: 1,
    slug: "mintimoney",
    title: "MintiMoney",
    description:
      "Cross-platform expense-sharing and personal finance app — group expenses, split bills, spending insights, AI-powered receipt scanning, and real-time sync.",
    longDescription:
      "Built and launched a cross-platform expense-sharing and personal finance application that enables users to manage group and personal expenses, split bills, track spending insights, and settle balances. Implemented AI-powered receipt scanning using OpenAI APIs, real-time data synchronization with Firestore, push notifications with FCM, and scalable backend services using Google Cloud Run. Designed and developed the complete product from concept to deployment, including mobile application, backend architecture, and user onboarding flows.",
    image:
      "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    categories: ["ai", "mobile", "fullstack"],
    categoryLabels: ["Mobile", "AI / ML", "Full-Stack"],
    technologies: [
      "React Native (TypeScript)",
      "Firebase Auth",
      "Firestore",
      "FCM",
      "Cloud Run",
      "OpenAI API",
      "Zustand",
      "React Navigation",
    ],
    link: "https://mintimoney.com",
    githubLink: null,
    featured: true,
    achievements: [
      "Full product ownership — concept to App Store deployment",
      "AI-powered receipt scanning via OpenAI APIs",
      "Real-time sync with Firestore",
      "Push notifications with Firebase Cloud Messaging",
      "Scalable backend on Google Cloud Run",
    ],
  },
  {
    id: 2,
    slug: "thread-magic",
    title: "Thread Magic",
    description:
      "Developed a tool to convert entire Twitter threads into well-organized, shareable PDF carousels, enhancing SocialPilot's feature set and user engagement.",
    longDescription:
      "Thread Magic analyzes Twitter thread structure and converts them into beautifully formatted PDF carousels. Integrated directly into SocialPilot's platform, it enabled users to repurpose content seamlessly and drove a 20% increase in content sharing metrics across SocialPilot's 150,000+ user base.",
    image:
      "https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    categories: ["ai", "fullstack"],
    categoryLabels: ["AI / ML", "Full-Stack", "SaaS"],
    technologies: ["React.js", "Node.js"],
    link: "https://www.socialpilot.co/free-tools/threadmagic",
    githubLink: null,
    featured: true,
    achievements: [
      "20% increase in user content sharing",
      "Shipped to 150,000+ active SocialPilot users",
    ],
  },
  {
    id: 3,
    slug: "socialpilot-shopify",
    title: "SocialPilot Shopify App",
    description:
      "Built a Shopify application for SocialPilot to enable store owners to schedule and publish social media posts directly from their Shopify admin.",
    longDescription:
      "Built a Shopify embedded application using Polaris design system and App Bridge that deep-integrates with SocialPilot's API. Integrated Shopify OAuth authentication, leveraged Polaris for a seamless native UI, and deployed using AWS for scalability. Contributed to expanding SocialPilot's integrations ecosystem and enhancing value for e-commerce clients.",
    image:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    categories: ["fullstack", "integration"],
    categoryLabels: ["Full-Stack", "E-commerce", "Integration"],
    technologies: [
      "Shopify Polaris",
      "React.js",
      "Node.js",
      "GraphQL API",
      "App Bridge",
      "Prisma",
    ],
    link: "https://apps.shopify.com/socialpilot",
    githubLink: null,
    featured: true,
    achievements: [
      "Native Shopify admin integration via App Bridge",
      "Shopify OAuth authentication",
      "Deployed on AWS for scalability",
      "Expanded SocialPilot's e-commerce integrations",
    ],
  },
  {
    id: 4,
    slug: "socialpilot-platform",
    title: "SocialPilot Platform",
    description:
      "Designed and delivered multi-tenant SaaS features for a platform serving 150,000+ users, supporting complex scheduling workflows, role-based access control, and distributed publishing operations.",
    longDescription:
      "Core contributor to SocialPilot's main platform. Built multi-tenant SaaS features using Node.js, TypeScript, React, and MongoDB. Optimised MongoDB queries and created indexes reducing critical API response times by 30%. Integrated Facebook Graph, LinkedIn, and Google APIs enabling automated social media publishing that saved users 5 hours per week. Leveraged AWS (EC2, S3, Lambda, API Gateway) to deploy scalable microservices ensuring 99.9% uptime.",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    categories: ["fullstack", "cloud"],
    categoryLabels: ["Full-Stack", "SaaS", "Cloud Architecture"],
    technologies: [
      "React.js",
      "TypeScript",
      "Node.js",
      "MongoDB",
      "AWS",
      "Redis",
    ],
    link: "https://socialpilot.co",
    githubLink: null,
    featured: true,
    achievements: [
      "30% API response time improvement via MongoDB query optimisation",
      "99.9% uptime via AWS microservices",
      "5 hours/week saved per user via API integrations",
      "150,000+ users on the platform",
    ],
  },
  {
    id: 5,
    slug: "ai-content-generation",
    title: "AI Content Generation",
    description:
      "Built AI-powered applications using OpenAI GPT APIs and model fine-tuning to build intelligent, domain-specific applications that generate dynamic and accurate content.",
    longDescription:
      "Integrated OpenAI GPT APIs into the content creation workflow, enabling AI-assisted caption writing, hashtag suggestions, and post optimisation. Worked on fine-tuning GPT models on domain-specific social media data to improve output relevance for marketing use cases, generating dynamic and accurate content for SocialPilot users.",
    image:
      "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    categories: ["ai", "backend"],
    categoryLabels: ["AI / ML", "GPT Fine-Tuning", "SaaS"],
    technologies: ["OpenAI API", "GPT Fine-Tuning", "Node.js", "React.js"],
    link: null,
    githubLink: null,
    featured: false,
    achievements: [
      "LLM fine-tuning for domain-specific content generation",
      "Agentic automation pipelines",
    ],
  },
  {
    id: 6,
    slug: "api-integrations",
    title: "Third-Party API Integrations",
    description:
      "Integrated Facebook Graph, LinkedIn, and Google APIs, enabling automated social media publishing features that saved users an average of 5 hours per week.",
    longDescription:
      "Designed and implemented the OAuth-based authentication flow and API adapters for Facebook Graph, LinkedIn, and Google. Built a unified integration layer that abstracts platform-specific APIs behind a common interface, automating social media publishing workflows for thousands of SocialPilot users.",
    image:
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80",
    categories: ["backend", "integration"],
    categoryLabels: ["API Integration", "Backend", "Automation"],
    technologies: [
      "Node.js",
      "Express.js",
      "REST APIs",
      "OAuth 2.0",
      "Facebook Graph API",
      "LinkedIn API",
      "Google API",
    ],
    link: null,
    githubLink: null,
    featured: false,
    achievements: [
      "5 hours/week saved per user on average",
      "Facebook Graph, LinkedIn, Google integrations",
      "Automated publishing workflows",
    ],
  },
];

// ─── Skills / Tech Stack ──────────────────────────────────────────────────────
// To add: append items to an existing category, or add a new category object.
export const skills = [
  {
    category: "AI / ML",
    slug: "ai",
    items: [
      "OpenAI API",
      "GPT Fine-Tuning",
      "LLM Fine-Tuning",
      "Agentic Automation Pipelines",
      "Generative AI",
    ],
  },
  {
    category: "Frontend",
    slug: "frontend",
    items: ["React.js", "Next.js", "Redux", "TypeScript", "JavaScript"],
  },
  {
    category: "Backend",
    slug: "backend",
    items: ["Node.js", "Express.js", "REST APIs", "Microservices"],
  },
  {
    category: "Databases",
    slug: "database",
    items: ["MongoDB", "MySQL", "Redis", "PostgreSQL"],
  },
  {
    category: "DevOps & Cloud",
    slug: "cloud",
    items: [
      "AWS EC2",
      "S3",
      "Lambda",
      "API Gateway",
      "SES",
      "CloudWatch",
      "EventBridge",
      "Elastic Beanstalk",
      "SQS",
      "RabbitMQ",
      "Kafka",
      "Cloud Run",
      "Docker",
    ],
  },
  {
    category: "Tools & Practices",
    slug: "tools",
    items: [
      "Git",
      "Jira",
      "Jest",
      "Cypress",
      "CI/CD Pipelines",
      "Agile / Scrum",
      "SaaS Application Development",
      "Third-party API Integrations",
    ],
  },
];

// ─── Experience ───────────────────────────────────────────────────────────────
// To add: prepend new entries (most recent first).
export const experience = [
  {
    id: 1,
    company: "SocialPilot",
    companySubtitle: "Social Media Publishing & Scheduling Tool",
    position: "Full Stack Developer",
    duration: "2021 — Present",
    year: "2021",
    location: "Ahmedabad, India",
    description:
      "Architecting and delivering AI-native, production-grade SaaS features for a platform serving 150,000+ users.",
    achievements: [
      "Built AI-powered applications using OpenAI GPT APIs and model fine-tuning to build intelligent, domain-specific applications that generate dynamic and accurate content",
      "Designed and delivered multi-tenant SaaS features using Node.js, TypeScript, React, and MongoDB for a platform serving 150,000+ users, supporting complex scheduling workflows, role-based access control, and distributed publishing operations",
      "Launched 'Thread Magic' — a tool that converts Twitter threads into carousel-style PDFs, increasing user content sharing by 20%",
      "Optimised MongoDB queries and created indexes, reducing critical API response times by 30%",
      "Integrated third-party APIs including Facebook Graph, LinkedIn, and Google APIs, enabling automated social media publishing that saved users an average of 5 hours per week",
      "Leveraged AWS services (EC2, S3, Lambda, API Gateway) to deploy scalable microservices, ensuring 99.9% uptime",
      "Collaborated with product managers, designers, and customer support to deliver features aligned with user needs and business goals",
      "Contributed to unit and integration testing using Jest and Cypress, improving code reliability and reducing production bugs",
    ],
  },
  {
    id: 2,
    company: "SocialPilot",
    companySubtitle: "Social Media Publishing & Scheduling Tool",
    position: "Node.js Developer — Intern",
    duration: "Feb 2021 — Jul 2021",
    year: "2021",
    location: "Ahmedabad, India",
    description:
      "Backend development focused on REST API design and production-grade software development practices.",
    achievements: [
      "Developed REST APIs for new UI features, ensuring clean architecture and performance optimisation",
      "Resolved production bugs and critical issues, enhancing platform stability and user satisfaction",
    ],
  },
];

// ─── Education ────────────────────────────────────────────────────────────────
export const education = [
  {
    id: 1,
    degree: "Masters of Computer Science in Information Technology",
    institution: "Indus University",
    location: "Ahmedabad, India",
    duration: "2019 — 2021",
    cgpa: "9.6 CGPA",
  },
  {
    id: 2,
    degree: "Bachelor of Computer Science in Information Technology",
    institution: "Indus University",
    location: "Ahmedabad, India",
    duration: "2016 — 2019",
    cgpa: "8.4 CGPA",
  },
];

// ─── Certifications ───────────────────────────────────────────────────────────
export const certifications = [
  {
    id: 1,
    name: "AWS Certified Solution Architect — Associate",
    issuer: "Amazon Web Services",
    year: "2023",
  },
  {
    id: 2,
    name: "Explore Generative AI with the Vertex AI Gemini API Skill Badge",
    issuer: "Google Cloud",
    year: "2024",
  },
  {
    id: 3,
    name: "Build Real World AI Applications with Gemini and Imagen Skill Badge",
    issuer: "Google Cloud",
    year: "2024",
  },
  {
    id: 4,
    name: "Prompt Design in Vertex AI Skill Badge",
    issuer: "Google Cloud",
    year: "2024",
  },
  {
    id: 5,
    name: "Develop GenAI Apps with Gemini and Streamlit Skill Badge",
    issuer: "Google Cloud",
    year: "2024",
  },
  {
    id: 6,
    name: "Inspect Rich Documents with Gemini Multimodality and Multimodal RAG Skill Badge",
    issuer: "Google Cloud",
    year: "2024",
  },
  {
    id: 7,
    name: "Cloud Computing",
    issuer: "NPTEL",
    year: "2023",
  },
];

// ─── Languages ────────────────────────────────────────────────────────────────
export const languages = ["Hindi", "English", "Gujarati"];
